export default __webpack_public_path__ + "static/media/uk.73bf4089.svg";